// src/components/UploadPhotoModal.jsx
import React, { useState, useCallback } from 'react';

const UploadPhotoModal = ({ onClose, onSave }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  const handleFileChange = (file) => {
    if (file && file.type.startsWith('image/')) {
      setSelectedFile(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const onDrop = useCallback((event) => {
    event.preventDefault();
    handleFileChange(event.dataTransfer.files[0]);
  }, []);

  const onDragOver = (event) => {
    event.preventDefault();
  };

  const handleUpload = () => {
    // Aquí iría la lógica para subir el 'selectedFile' a Firebase Storage
    console.log("Subiendo archivo:", selectedFile.name);
    onSave(previewUrl); // Por ahora, solo actualizamos el frontend con la previsualización
    onClose();
  };

  return (
    <>
      <div className="settings-overlay" onClick={onClose}></div>
      <div className="confirmation-modal">
        <h3>Cambiar Foto de Perfil</h3>
        <div 
          className="drop-zone"
          onDrop={onDrop}
          onDragOver={onDragOver}
        >
          {previewUrl ? (
            <img src={previewUrl} alt="Previsualización" className="image-preview" />
          ) : (
            <p>Arrastra y suelta tu imagen aquí, o haz clic para seleccionarla.</p>
          )}
          <input 
            type="file" 
            accept="image/*"
            onChange={(e) => handleFileChange(e.target.files[0])}
            style={{ display: 'none' }}
            id="file-upload"
          />
        </div>
        <label htmlFor="file-upload" className="profile-button" style={{marginTop: '16px'}}>
          Seleccionar Archivo
        </label>
        <div className="modal-footer">
          <button className="profile-button" onClick={onClose}>Cancelar</button>
          <button className="profile-button profile-button--primary" onClick={handleUpload} disabled={!selectedFile}>
            Subir Foto
          </button>
        </div>
      </div>
    </>
  );
};

export default UploadPhotoModal;